<template>
    <div v-if="bPrompt">
        <h1>I am first div.</h1>
        <button @click="turnOver">切换</button>
    </div>
    <div v-else>
        <h1>I am second div.</h1>
        <button @click="turnOver">切换</button>
    </div>
</template>

<script>
    export default {
        name: "test",
        data(){
            return {
                bPrompt: false
            }

        },
        methods:{
            turnOver(){
                this.bPrompt = !this.bPrompt;
            }
        }
    }
</script>

<style scoped>

</style>